/**
 * Moved to `@sizzlenz/shared-frontend/providers`.
 * Re-exported here so existing `@/lib/contexts/LocalSettingsContext` imports keep working.
 */
export {
  LocalSettingsProvider,
  useLocalSettings,
  type LocalSettingsProviderProps,
} from '@sizzlenz/shared-frontend/providers';
